<template>
  <div class="content-box">
    <div class="recommand-swiper">
      <mt-swipe :auto="4000" class="swiper">
        <mt-swipe-item
          v-for="(item, index) in recommandList"
          :key="index"
          @click.native="routeReadSwiper(item)"
        >
          <div class="swiper-item uni-bg-red">
            <img class="swiper-item-image" :src="item.bookLogoUrl" alt="" />
            <div class="swiper-item-div">
              <span class="book_name">{{ item.bookName }}</span>
              <span class="book_summary">{{ item.bookSummary }}</span>
            </div>
          </div>
        </mt-swipe-item>
      </mt-swipe>
      <img
        class="recommand-icon"
        src="../../static/today-recommend.png"
        alt=""
      />
    </div>
    <!-- 书架列表 -->
    <div class="bookself_contaner" v-if="!isEmpty">
      <div class="bookself_title">
        <span class="book_title">书架中共{{ count }}本书</span>
        <span class="bookself_edit" @click="changeEdit">{{
          isEdit ? "编辑完成" : "管理书架"
        }}</span>
      </div>
      <div class="list_bookself">
        <ul
          v-infinite-scroll="loadMore"
          :infinite-scroll-disabled="loading"
          infinite-scroll-distance="10"
        >
          <!--     :style="{ marginLeft: index % 3 == 0'20px' }" -->
          <li
            class="list-item"
            v-for="(item, index) in bookSelfList"
            :key="index"
            @click="routeRead(item)"
            @touchstart="getTouchStart(item)"
            @touchend="getTouchEnd"
            :style="{ marginLeft: index % 3 == 0 ? '1rem' : '1.25rem' }"
          >
            <div>
              <img class="book_cover" :src="item.bookLogoUrl" alt="" />
              <span class="list-item-text book_itemname">{{
                item.bookName
              }}</span>
              <span class="list-item-text book_pos"
                >{{ item.chapterPos > 0 ? item.chapterPos + "章" : "未读" }} /
                {{ item.numChapters }}章</span
              >
              <img
                class="close_image"
                @click="deleteBookSelf(item)"
                v-if="isEdit"
                src="../../static/delete.png"
                alt=""
              />
              <img
                v-if="index == 0 && item.chapterPos > 0"
                class="today-icon"
                src="../../static/last-icon.png"
                alt=""
              />
              <img
                v-if="item.chapterPos == 0"
                class="today-icon"
                style="width: 32px"
                src="../../static/recommend-selficon.png"
                alt=""
              />
            </div>
          </li>
          <li
            :style="{
              marginLeft: bookSelfList.length % 3 == 0 ? '1rem' : '1.25rem',
            }"
            v-if="loadingText == '没有更多了' && !isEdit"
            class="list-item"
          >
            <div class="list-more" @click="routeIndex">
              <img
                class="list-more-image"
                src="../../static/check_city.png"
                alt=""
              />
              <span class="list-more-text">点我发现更多好书</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="load-more" v-if="loadingText == '加载中...' && !isEmpty">
      <span>{{ loadingText }}</span>
    </div>
    <div class="no-log" v-if="isEmpty">
      <img class="no-log-image" src="../../static/no-log.png" alt="" />
      <span class="tips-no">书架空空如也</span>
      <span class="tips-btn" @click="routeIndex">发现更多好书</span>
    </div>
    <buyBook
      :showBuyMask="showBuyMask"
      :countCurrency="countCurrency"
      @buyChange="buyChange"
      :userCurrency="userCurrency"
    ></buyBook>
  </div>
</template>
<script>
import { Toast, MessageBox, Loadmore } from "mint-ui";
import buyBook from "../view/components/buyBook.vue";
export default {
  components: {
    buyBook,
  },
  data() {
    return {
      allLoaded: false, //数据是否加载完毕
      loading: false,
      countCurrency: 0, //整本书币，
      showBuyMask: false, //显示整本订购弹窗
      userCurrency: 0, //用户剩余书币
      purchaseWholeBook: 0,
      isEmpty: false,
      count: 1,
      currentIndex: 1,
      pageSize: 18,
      pageNo: 1,
      CountPage: 0,
      isEdit: false,
      recommandList: [],
      bookSelfList: [],
      loadingText: "加载中...",
      isReload: false,
      item: {},
      sufuTimer: null,
    };
  },
  mounted() {},
  methods: {
    loadMore() {
      this.loading = true;
      if (this.CountPage > this.pageNo) {
        this.pageNo += 1;
        this.myBookshelf();
      } else {
        this.loading = false;
        this.loadingText = "没有更多了";
      }
    },
    contentFun() {
      this.currentIndex = this.$base.getStorage("currentIndex");
      this.pageNo = 1;
      this.bookSelfList = [];
      this.getBookShelfList();
      this.myBookshelf();
      this.insertPageAccessData();
      this.getOrderStatus(); //判断订单号是否支付成功
    },
    insertPageAccessData() {
      var params = {
        pageName: "书架",
        pageRemark: "",
      };
      this.$api.insertPageAccessData(params).then((res) => {});
    },
    routeIndex() {
      this.$emit("eventChange", { data: 1 });
    },
    changeEdit() {
      this.isEdit = !this.isEdit;
    },
    getBookShelfList() {
      var params = {
        frequency: this.currentIndex,
      };
      this.$api.getBookShelfList(params).then((res) => {
        if (res.status == 1) {
          this.recommandList = res.data;
        }
      });
    },
    myBookshelf() {
      var params = {
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        isNewPage: 1,
      };
      if (this.pageNo == 1) {
        this.$nextTick(() => {
          window.scrollTo(0, 0);
        });
      }
      this.$api.myBookshelf(params).then((res) => {
        if (res.status == 1) {
          this.count = res.counts;
          this.CountPage = res.pages;
          if (this.pageNo <= this.CountPage) {
            if (this.pageNo == 1) {
              this.bookSelfList = res.data;
              if (this.CountPage > 1) {
                this.loadingText = "加载中...";
              } else {
                this.loadingText = "没有更多了";
              }
            } else {
              this.bookSelfList = this.bookSelfList.concat(res.data);
            }
          }
          if (this.count == 0) {
            this.isEmpty = true;
          }
        }
      });
    },
    deleteBookSelf(item) {
      var params = {
        userBookshelfIds: item.bookId,
      };
      this.$api.deleteBookshelf(params).then((res) => {
        if (res.status == 1) {
          this.pageNo = 1;
          this.myBookshelf();
          Toast({
            message: "书籍删除成功！",
          });
        }
      });
    },
    getOrderStatus() {
      if (
        this.$base.getStorage("orderNum") &&
        this.$base.getStorage("isActivity")
      ) {
        var params = {
          orderNo: this.$base.getStorage("orderNum"),
          currentPageType: 1,
        };
        this.$api.getOrderStatus(params).then((res) => {
          this.$base.removeStorage("orderNum");
          this.$base.removeStorage("isActivity");
          if (res.status == 1) {
            Toast({
              message: res.message,
            });
          }
        });
      }
    },
    buyChange(data) {
      if (data) {
        if (data == 1) {
          this.purchaseWholeBook = 1;
          this.routeRead(this.item);
        } else if (data == 2) {
          this.showBuyMask = false;
          this.$router.push({
            path: "/pages/bookCharge/index",
            query: {
              bookId: this.item.bookId,
              needCurrency: this.countCurrency,
              pageType: "bookRead",
            },
          });
        }
      } else {
        this.showBuyMask = false;
      }
    },
    routeRead(item) {
      if (!this.isEdit) {
        this.item = item;
        // // 跳转到阅读器
        var params = {
          bookId: item.bookId,
          chapterId: item.chaptersId, //章节排序order
          chapterorder: item.chapterPos, //翻页标示 0:获取当前章节内容 1: 前一章 2：后一章,4从目录进入阅读器,3购买章节
          order: 0,
          booktype: "",
          isauto: 0,
          rechargeOrderNum: "", //订单编号
          purchaseWholeBook: this.purchaseWholeBook,
          currentPageType: 1,
        };
        this.$api.findChapterContentByChapterId(params).then((res) => {
          if (res.status == 1) {
            this.showBuyMask = false;
            this.purchaseWholeBook = 0;
            this.$router.push({
              path: "/pages/bookRead/index",
              query: {
                bookid: item.bookId,
                pageType: "bookSelf",
              },
            });
          } else if (res.status == 3) {
            this.showBuyMask = true;
            this.countCurrency = res.data.wholeBookCurrency;
            this.userCurrency = res.data.accountCurrency;
          } else if (res.status == 100 || res.status == 200||res.status==4) {
            if (res.data) {
              if(res.status==100&&res.data.priceType==3){
              this.$router.push({
                path: "/pages/bookCharge/index",
                query: {
                  bookId: item.bookId,
                  chapterId: res.data.id,
                  needCurrency: res.data.chapterPrice,
                  pageType: "bookRead",
                  priceType:res.data.priceType
                },
              });
              }else{
                this.$router.push({
                path: "/pages/bookCatalog/index",
                query: {
                  bookId: item.bookId,
                },
              });
              }
             
             
            }
          }
        });
      }
    },
    routeReadSwiper(item) {
     
      this.$router.push({
        path: "/pages/bookRead/index",
        query: {
          bookid: item.bookId,
          pageType: "bookSelf",
        },
      });
    },
    getTouchStart(item) {
      clearTimeout(this.sufuTimer);
      this.sufuTimer = setTimeout(() => {
        //  你要做的功能
        this.longCheckpress(item);
      }, 1000);
    },
    getTouchEnd() {
      clearTimeout(this.sufuTimer);
    },
    longCheckpress(item) {
      MessageBox.confirm("是否将此书从书架中删除？").then((action) => {
        if (action == "confirm") {
          this.deleteBookSelf(item);
        }
      });
    },
  },
};
</script>

<style scoped>
.recommand-swiper >>> .mint-swipe-indicator {
  background-color: #d8d8d8;
  opacity: 1;
}
.recommand-swiper >>> .mint-swipe-indicator.is-active {
  background: #de3b34;
}
.content-box {
  /* height:calc(48px + env(safe-area-inset-bottom)); */
  padding-bottom: constant(safe-area-inset-bottom);
  /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom);
  /* 兼容 iOS >= 11.2 */
  /* box-sizing: content-box; */
}
.recommand-swiper {
  padding: 24px 16px 16px 16px;
  background-image: linear-gradient(0deg, #ffffff 0%, #de3b34 100%);
  position: relative;
}

.swiper {
  background-color: #ffffff;
  padding: 16px;
  border-radius: 8px;
  box-sizing: border-box;
  padding-bottom: 0px;
  /* width: 328px; */
  height: 151px;
}

.recommand-icon {
  width: 36px;
  height: 42px;
  position: absolute;
  right: 32px;
  top: 34px;
}

.swiper-item {
  display: flex;
}

.swiper-item > .swiper-item-image {
  width: 80px;
  height: 106px;
  border-radius: 8px;
}

.swiper-item > .swiper-item-div {
  width: 205px;
  margin-left: 12px;
  position: relative;
}

.book_name {
  color: #333333;
  font-weight: bold;
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  margin-bottom: 12px;
  font-size: 15px;
  width: 140px;
}

.book_summary {
  font-size: 12px;
  color: #aaaaaa;
  overflow: hidden;
  -webkit-line-clamp: 3;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  position: absolute;
  right: 0px;
  bottom: 0px;
  line-height: 17px;
}
.bookself_title {
  display: flex;
  margin-left: 16px;
  margin-right: 16px;
  justify-content: space-between;
}

.book_title {
  font-size: 15px;
  color: #333333;
  font-weight: bold;
}

.bookself_edit {
  font-size: 14px;
  color: #de3b34;
}

.list_bookself {
  overflow: hidden;
}
.list_bookself ul {
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
}
.list_bookself .list-item {
  margin-top: 16px;
  width: 96px;
  margin-left: 16px;
}
.list-item > div {
  /* width: 96px; */
  position: relative;
}
.list-item .book_cover {
  width: 96px;
  height: 128px;
  border-radius: 8px;
  pointer-events: none;
}
.close_image {
  position: absolute;
  right: -12px;
  top: -12px;
  width: 24px;
  height: 24px;
}

.today-icon {
  position: absolute;
  left: 0px;
  top: 12px;
  width: 51px;
  height: 20px;
}

.list-item .list-item-text {
  display: -webkit-box;
}

.book_itemname {
  color: #333333;
  margin-top: 10px;
  margin-bottom: 4px;
  overflow: hidden;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  width: 80px;
}
.book_pos {
  font-size: 12px;
  color: #aaaaaa;
}
.load-more {
  text-align: center;
  font-size: 12px;
  color: #aaaaaa;
  padding: 16px 0px;
}

.list-more {
  width: 100%;
  height: 128px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #dddddd;
}
.list-more-image {
  width: 24px;
  height: 24px;
  display: block;
  margin: 0 auto;
  margin-bottom: 8px;
  margin-top: 32px;
}
.list-more-text {
  font-size: 11px;
  color: #aaaaaa;
  width: 48px;
  display: block;
  margin: 0 auto;
}
.no-log > .no-log-image {
  display: block;
  width: 88px;
  height: 88px;
  margin: 0 auto;
  margin-top: 100px;
}
.tips-no {
  text-align: center;
  display: block;
  margin: 12px auto;
  font-size: 12px;
}
.tips-btn {
  margin: 0 auto;
  display: block;
  background-color: #de3b34;
  color: #ffffff;
  font-size: 12px;
  width: 103px;
  height: 24px;
  align-items: center;
  text-align: center;
  border-radius: 20px;
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/bookSelf.vue